var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5471 9.0585C16.9233 6.29402 13.6672 8.09328 12.0087 8.07958C10.6099 8.06 10.1765 6.88529 8.15155 6.88333C5.934 6.88333 4.38234 8.12265 3.57824 9.56559C2.26739 11.962 3.05474 17.2932 7.29091 19.8189C11.1585 22.1232 16.4061 20.8017 18.9189 18.0411C21.4317 15.2806 21.6998 11.3296 19.5471 9.0585ZM15.4806 18.1234C14.0399 18.9731 12.5615 18.5149 12.1302 18.231C12.0087 18.1508 12.0045 17.9843 12.1804 17.9511C13.069 17.7655 13.9183 17.4426 14.6932 16.9956C15.4381 16.5625 16.0952 16.0097 16.6344 15.3628C16.7516 15.214 16.7809 15.1787 16.8605 15.1787C16.9401 15.1787 16.9757 15.2492 17.0029 15.353C17.1453 15.8542 16.9527 17.256 15.4764 18.1234",
    fill: "#D31820"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8285 7.23973C11.5333 7.1947 11.4411 6.7209 11.5165 6.13354C11.6086 5.43263 12.0609 4.66124 13.2797 4.34407C14.9088 3.91921 15.336 3.81349 15.8532 3.56093C16.1351 3.42227 16.3992 3.25412 16.6405 3.05972C16.6688 3.03483 16.7032 3.01688 16.7407 3.00748C16.7782 2.99808 16.8176 2.99753 16.8553 3.00588C16.8931 3.01422 16.9281 3.0312 16.9571 3.05529C16.9861 3.07938 17.0083 3.10983 17.0216 3.14391C17.2164 3.60204 17.5033 5.61471 15.2522 6.12571C14.3836 6.30768 13.5282 6.54114 12.6912 6.82466C12.063 7.07331 12.0903 7.28084 11.8285 7.23973Z",
    fill: "#D31820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus);
export default __webpack_public_path__ + "static/media/bonus.4ba03971d25d8d56ed3e41239afda204.svg";
export { ForwardRef as ReactComponent };